// extracted by mini-css-extract-plugin
export var infoRow = "_pn-2";
export var labelContainer = "_pn-0";
export var rightInfo = "_pn-1";